export default __webpack_public_path__ + "static/media/avatar.46359ea8.png";